import { useState } from "react";
import { Container } from "react-bootstrap";
import FreelancerserplaceNavbar from "../../signup/SubComponents/FreelancerserplaceNavbar";
import RegisterModal from "../../signup/RegisterModal";
import Footer from "../../signup/SubComponents/Footer";
import { MockProjectsDashboard } from "./Components/MockScreens";

const ProjectsLandingpage = () => {
  const [showRegister, setShowRegister] = useState(false);

  const features = [
    {
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/>
        </svg>
      ),
      title: "Project Overview",
      text: "See all your active projects at a glance. Track status, deadlines and budgets without digging through emails.",
    },
    {
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="9 11 12 14 22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>
        </svg>
      ),
      title: "Task Management",
      text: "Break projects into tasks, set priorities and mark them done as you go. Stay organised throughout.",
    },
    {
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
        </svg>
      ),
      title: "Time & Budget Tracking",
      text: "Set max hours and daily rates. See how much time you've logged against your budget in real time.",
    },
    {
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>
      ),
      title: "Client-linked Projects",
      text: "Connect every project to a client from your CRM. Everything stays linked — contacts, invoices, time entries.",
    },
  ];

  return (
    <>
      <RegisterModal show={showRegister} setShow={setShowRegister} showLoginForm={false} />
      <FreelancerserplaceNavbar />

      {/* Hero */}
      <div className="lp-hero-bg">
        <Container>
          <div style={{
            display: "grid", gridTemplateColumns: "1fr 1fr",
            gap: "3rem", alignItems: "center",
            paddingTop: "5rem", paddingBottom: "5rem",
            position: "relative",
          }}>
            <div className="yellowdotWelcome" />
            <div className="greendotWelcome" />
            <div>
              <div className="lp-badge">Projects</div>
              <h1 className="lp-hero-title">
                Deliver projects <span style={{ color: "#007BFF" }}>on time, every time</span>
              </h1>
              <p className="lp-hero-subtitle">
                Keep every project on track from kickoff to invoice. Manage tasks, track time and monitor budgets — all in one place.
              </p>
              <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap", alignItems: "center" }}>
                <button className="lp-cta-btn btn btn-primary" onClick={() => setShowRegister(true)}>
                  Try now for free
                </button>
                <a href="https://demo.freelancersplace.net" target="_blank" rel="noreferrer" className="lp-demo-link">
                  View demo →
                </a>
              </div>
              <div className="lp-trust-badges">
                <span>✓ 30-day free trial</span>
                <span>✓ No credit card required</span>
              </div>
            </div>

            <div>
              <div className="reddotWelcome" />
              <MockProjectsDashboard />
            </div>
          </div>
        </Container>
      </div>

      {/* Feature grid */}
      <div className="lp-section-alt">
        <Container>
          <div style={{ paddingTop: "4rem", paddingBottom: "4rem" }}>
            <div style={{ textAlign: "center", marginBottom: "3rem" }}>
              <span className="blueSubheaderTop">Everything you need</span>
              <h2 className="landingpageHeader" style={{ fontWeight: 400, marginTop: "0.5rem" }}>
                Project management made simple
              </h2>
            </div>
            <div style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
              gap: "1.25rem",
            }}>
              {features.map(({ icon, title, text }) => (
                <div key={title} style={{
                  background: "#fff",
                  border: "1px solid #e8edf5",
                  borderRadius: "1rem",
                  padding: "1.5rem",
                  transition: "box-shadow 0.15s, transform 0.15s",
                }}
                  onMouseOver={e => { e.currentTarget.style.boxShadow = "0 8px 32px rgba(0,0,0,0.1)"; e.currentTarget.style.transform = "translateY(-2px)"; }}
                  onMouseOut={e => { e.currentTarget.style.boxShadow = "none"; e.currentTarget.style.transform = "none"; }}
                >
                  <div style={{
                    width: "44px", height: "44px", borderRadius: "10px",
                    background: "#e8f1ff", display: "flex", alignItems: "center",
                    justifyContent: "center", color: "#007BFF", marginBottom: "1rem",
                  }}>
                    {icon}
                  </div>
                  <h4 style={{ fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700, fontSize: "1rem", marginBottom: "0.5rem" }}>
                    {title}
                  </h4>
                  <p className="landingpageDescriptions" style={{ marginBottom: 0 }}>{text}</p>
                </div>
              ))}
            </div>
          </div>
        </Container>
      </div>

      {/* CTA */}
      <Container>
        <div style={{
          textAlign: "center", padding: "5rem 1rem",
          borderBottom: "1px solid #f0f0f0",
        }}>
          <h2 className="landingpageHeader" style={{ fontWeight: 400 }}>
            Ready to manage your projects smarter?
          </h2>
          <p className="landingpageDescriptions" style={{ maxWidth: "480px", margin: "0 auto 2rem" }}>
            Join freelancers who use FreelancersPlace to stay organised, hit deadlines and get paid for every hour.
          </p>
          <button className="lp-cta-btn btn btn-primary" onClick={() => setShowRegister(true)}>
            Start free trial
          </button>
        </div>
      </Container>

      <Footer />
    </>
  );
};

export default ProjectsLandingpage;
